import React from 'react';
import { HelpCircle, ArrowRight, Check, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const AnswerFAQPage = () => {
  const { login } = useAuth();

  const features = [
    'Respostas instantâneas 24/7',
    'Base de conhecimento IA',
    'Aprende com interações',
    'Escalação para humano',
  ];

  const faqs = [
    'Qual o horário de funcionamento?',
    'Como faço para trocar um produto?',
    'Qual o prazo de entrega?',
    'Vocês parcelam?',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <HelpCircle className="h-4 w-4" />
                FAQ Automático
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Responda <span className="text-yellow-500">perguntas frequentes</span> automaticamente
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                O chatbot responde às dúvidas mais comuns instantaneamente, 24 horas por dia.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="bg-gray-50 rounded-3xl p-6">
              <p className="text-sm font-medium text-gray-700 mb-4">Perguntas frequentes:</p>
              <div className="space-y-2">
                {faqs.map((faq) => (
                  <div key={faq} className="bg-white rounded-xl p-4 flex items-center gap-3 cursor-pointer hover:shadow-md transition-shadow">
                    <MessageSquare className="h-5 w-5 text-[#3b82f6]" />
                    <span className="text-sm">{faq}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Automatize suas respostas de FAQ</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AnswerFAQPage;
